export const TASKS_VIEW_TEAM_MEMBER_FILTER_KEY = 'task-view-team-member-id';

export const TRIAL_DISABLED_USERS = ['65cc1cd1252fe14c52eee6fb'];
